import * as yup from "yup";

export const SubOrgValidation = yup.object({
  name: yup.string().required("Please enter organization name"),
  country_id: yup.number().required("Please choose country"),
  state_id: yup.number().required("Please choose state"),
  fiscal_year: yup.string().required("Please select the fiscal year."),
});
